/**
 * Created by Mark on 19/04/2017.
 */


/**
 * Created by Mark on 17/04/2017.
 */

import React  from 'react';
import Layout from '../components/layouts/standard-page.js';
import TeacherForm from '../components/forms/teacher-form.js';
import Card from '../components/card.js';
import CardBody from '../components/card-body.js';
import CardHead from '../components/card-header.js';
export default class ScoresComponent extends React.Component {

    constructor(props) {
        super();
    }


    render(){
        return (<Layout>
            <Card>
                <CardHead>
                    <h2>Create New Staff Member<small></small></h2>
                </CardHead>
                <CardBody>
                    <TeacherForm />
                </CardBody>
            </Card>
        </Layout>);
    }
}




// WEBPACK FOOTER //
// ./src/screens/staff-creation.js